module.exports = __webpack_public_path__ + "img/179997.83bd9bd8.png";